import * as React from "react";
import { credentials, UserResponseModel } from "src/models/general-models";
import { ContactModel, PeopleObject } from "src/models/contact-models";
import { getString } from "src/server/graphDB-utils";
import { authenticateUser, verifyOTP, resendOTP, ChangePasswordEmail, fetchPeople, SendEmailForgetPassword, fetchGuestUser, checkUserExists_Mongo, addInstanceInfo_Mongo } from "src/server/utils/contact-utils";
import { showHideLoadingDiv } from "src/loaders/StyleLoader";
import StorageUtils from "src/server/utils/storage-utils";
import { redirectBackToApp } from "src/server/utils/general-utils";

interface Props {
    instance: string;
    verifyOTP: boolean;
    forgetPassword?: boolean;
}

interface State {
    instance: string;
    Credentials: credentials;
    verifyOTP: boolean;
    otpBySms: boolean;
    forgetPassword?: boolean;
    isEmailSent?: boolean;
    PeopleList: PeopleObject[];
    mlogin: boolean;
    instances: string[]
}

class Login extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            instance: this.props.instance,
            mlogin: false,
            instances: [],
            Credentials: { password: "", username: "" }, verifyOTP: this.props.verifyOTP, otpBySms: true, forgetPassword: this.props.forgetPassword ? this.props.forgetPassword : false, isEmailSent: false, PeopleList: []
        }
        this.handleLoginForm = this.handleLoginForm.bind(this);
        this.authenticate = this.authenticate.bind(this);
        this.verifyOTP = this.verifyOTP.bind(this);
        this.resendOTP = this.resendOTP.bind(this);
        this.manageSendEmail = this.manageSendEmail.bind(this);
    }

    async componentDidMount() {
        StorageUtils.clear();
        const PeopleList = await fetchPeople();
        this.setState({ PeopleList })
        // await checkSession().then((res) => {
        //     if (res && res.success) {
        //         redirectBackToApp(this.props.instance);
        //     }
        // }).catch(err => {
        //     return err;
        // });
    }

    async handleLoginForm(e) {
        let Credentials = this.state.Credentials;
        let name = e.target.name;
        let value = e.target.value;;
        Credentials[`${name}`] = value;
        this.setState({ Credentials });
    }

    async clickSigninWithUsername() {
        const { Credentials } = this.state;
        let instance = this.state.instance;
        let instances = [];
        if (Credentials.username) {
            const response = await checkUserExists_Mongo(Credentials.username);
            if (response && response.code == 200 && response.exists) {
                Credentials.name = response.label;
                if (response.i && response.i.length == 1)
                    instance = response.i[0];
                else
                    instances = response.i;
                this.setState({ Credentials, mlogin: true, instance, instances })
            } else {
                alert("No Username found")
            }
        }
    }

    async authenticate() {
        showHideLoadingDiv(true);
        let user: ContactModel = Object();
        const { Credentials, instance } = this.state;
        await authenticateUser(Credentials, this.state.otpBySms, instance).then((contacts) => {
            if (contacts && contacts.length > 0) {
                const isGuestAccess = this.state.instance == "GuestAccess";
                let contact = contacts[0];

                if (isGuestAccess && contacts[0]) {
                    const response: any = contacts[0];
                    contact = response.user;
                    contact.token = response.token;
                }

                if (getString(contact.contact)) {
                    user.contact = getString(contact.contact);
                    user.name = getString(contact.name);
                    user.mobile = isGuestAccess ? getString((contact as any).mobile) : getString(contact.phone);
                    user.email = getString(contact.email);
                    user.extendShiftTime = getString(contact.extendShiftTime);
                    user.group = getString(contact.group);
                    user.role = getString(contact.role);
                    user.facility = getString(contact.assignedTo);
                    user.smsSchedule = getString(contact.smsSchedule);
                    user.stripePaymentMethodId = getString(contact.stripePaymentMethodId);
                    user.stripeCustomerId = getString(contact.stripeCustomerId);
                    user.stripeSubscriptionId = getString(contact.stripeSubscriptionId);
                    user.company = getString(contact.company);
                    user.streetAddress = getString(contact.street);
                    user.city = getString(contact.city);
                    user.state = getString(contact.state);
                    user.zipcode = getString(contact.zipcode);
                    user.notes = getString(contact.notes);
                    user.shiftEndTime = contact.shiftEndTime && getString(contact.shiftEndTime) ? new Date(getString(contact.shiftEndTime)) : undefined;
                    user.shiftStartTime = contact.shiftStartTime && getString(contact.shiftStartTime) ? new Date(getString(contact.shiftStartTime)) : undefined;
                    user.loginTime = new Date().toString();
                    user.profileImage = getString(contact.profileImage);
                    user.allowAutoSMS = getString(contact.allowAutoSMS) == "true" ? true : false;
                    user.utilityOntologies = getString(contact.utility)

                    const data = getString(contact.qualifications).split(",")
                    let qualifications = [];
                    for (let i = 0; i < data.length; i++) {
                        qualifications[i] = data[i]
                    }
                    user.qualifications = qualifications;

                    const depts = getString(contact.departmentsAndGroups) && getString(contact.departmentsAndGroups).split(",");
                    if (depts && depts.length) {
                        user.departmentsAndGroups = depts.map(x => { return { label: x, value: x } });
                    }
                    // user.signatureDataURL = getString(contact.signatureDataURL);

                    StorageUtils.setItem('user', JSON.stringify(user));
                    StorageUtils.setItem('token', contact.token);
                    StorageUtils.setItem('instance', this.state.instance);

                    // if Guest Access, no need to send and verify OTP
                    if (isGuestAccess) {
                        StorageUtils.setItem('verifyOTP', '0');
                        redirectBackToApp(this.state.instance);
                    } else {
                        StorageUtils.setItem('verifyOTP', '1');
                        this.setState({ verifyOTP: true });
                    }
                    // window.location.hash="/Buildings";
                    // ................uncomment this line after login work........................
                    //window.location.reload();
                }
                else {
                    alert("login failed");
                }
            }
            else {
                alert("login failed");
            }
            showHideLoadingDiv(false);
        }).catch((reason: any) => {
            showHideLoadingDiv(false);
        });
    }

    async verifyOTP() {
        showHideLoadingDiv(true);
        await verifyOTP(this.state.Credentials.otp, this.state.otpBySms, this.state.instance).then((response: any) => {
            if (response && response.success) {
                StorageUtils.setItem('token', response.token);
                StorageUtils.setItem('verifyOTP', '0');
                redirectBackToApp(this.state.instance);
            }
            else {
                alert("Code not verified, please enter correct Code!");
            }
            showHideLoadingDiv(false);
        }).catch((reason: any) => {
            showHideLoadingDiv(false);
        });
    }

    async resendOTP() {
        showHideLoadingDiv(true);
        await resendOTP(this.state.otpBySms, this.state.instance).then((response: any) => {
            if (response && response.success) {
                StorageUtils.setItem('token', response.token);
                StorageUtils.setItem('verifyOTP', '1');
                this.setState({ verifyOTP: true });
                alert("A new code is sent to your mobile!");
            }
            else {
                alert("Code Resend failed");
            }
            showHideLoadingDiv(false);
        }).catch((reason: any) => {
            showHideLoadingDiv(false);
        });
    }

    cancelCreds() {
        this.setState({ Credentials: { password: "", username: "" }, instance: "", mlogin: false })
    }

    async cancel() {
        StorageUtils.clear();
        this.setState({ verifyOTP: false });
    }

    async manageSendEmail() {
        const { Credentials, PeopleList } = this.state;

        const isGuestAccess = this.state.instance == "GuestAccess"

        if (isGuestAccess) {
            const guestUser = await fetchGuestUser(Credentials.username);
            if (guestUser && guestUser._id) {
                const data: any = await ChangePasswordEmail(5, Credentials.username);
                if (data._id) {
                    SendEmailForgetPassword(guestUser.email, guestUser.contact, data.key)
                }
                else {
                    alert("Error while changing password");
                }
                this.setState({ isEmailSent: true, forgetPassword: false })
            } else {
                Credentials.username = "";
                this.setState({
                    Credentials
                }, () => {
                    alert("Invalid UserName");
                })
            }
        } else {
            const isValidUser: boolean = !!PeopleList.find(x => getString(x.contact) == Credentials.username);
            if (isValidUser) {
                const data: any = await ChangePasswordEmail(5, Credentials.username);
                if (data._id) {
                    const user = await fetchPeople("", [data.userOntology]);
                    SendEmailForgetPassword(getString(user[0].email), getString(user[0].contact), data.key)
                }
                else {
                    alert("Error while changing password");
                }
                this.setState({ isEmailSent: true, forgetPassword: false })
            }
            else {
                Credentials.username = "";
                this.setState({
                    Credentials
                }, () => {
                    alert("Invalid UserName");
                })
            }
        }
    }

    loginAsGuestUser() {
        window.location.href = "/#GuestAccess"
    }

    async addInstance(instance: string) {
        const { username } = this.state.Credentials;
        const response: UserResponseModel = await addInstanceInfo_Mongo(instance, username);
        if (response && response.code == 200) {
            this.setState({ instance })
        }
    }

    render() {
        const { Credentials, verifyOTP, forgetPassword, isEmailSent, instance, mlogin, otpBySms, instances } = this.state;
        let isValidData: boolean = Credentials.username && Credentials.password && true;

        let isValidUser: boolean = Credentials.username && true;

        if (verifyOTP) {
            isValidData = Credentials.otp && Credentials.otp > 99999 && Credentials.otp < 1000000 && true;
        }

        return (
            <div className="container">
                <div className="card card-container" id="divLogin">
                    <div className="divimg"><img id="profile-img" className="companyLogo" src="assets/img/new logo.png" /></div>
                    <p id="profile-name" className="profile-name-card"></p>
                    {!verifyOTP && !forgetPassword && !isEmailSent && <>
                        <span id="reauth-email" className="reauth-email"></span>
                        {!mlogin && <div className="row padding-5">
                            <input type="text" id="inputEmail" name="username" className="form-control" placeholder="User Name" required onChange={(e) => this.handleLoginForm(e)} />
                        </div>}
                        {mlogin &&
                            <>
                                <div className="center"><label style={{ fontSize: "larger", fontWeight: "700", margin: "20px" }}> Welcome {Credentials.name ? Credentials.name : Credentials.username} </label></div>

                                {instances && instances.length > 0 && <div className="row" style={{ marginBottom: "10px" }}>
                                    <div className="col-md-4">
                                        <label>Instance</label>
                                    </div>
                                    <div className="col-md-8">
                                        <select className={`form-control ${instance ? "" : "addFieldValidate"}`} name="instance" value={instance}
                                            onChange={(e) => this.setState({ instance: e.target.value })}>
                                            <option value="" key={-2} >Select Instance</option>
                                            {instances.map((x, i) => { return (<option value={x} key={i} >{x} </option>) })}
                                        </select>
                                    </div>
                                </div>}
                            </>}
                        {instance && <div className="row padding-5">
                            <input type="password" id="inputPassword" name="password" className="form-control" placeholder="Password" onKeyPress={(e) => { if (e.charCode == 13) { this.authenticate() } }} required onChange={(e) => this.handleLoginForm(e)} />
                        </div>}
                        {instance && instance != "GuestAccess" && <div className="form-check row padding-5">
                            <div style={{ width: "50%", display: "inline-flex" }}>
                                <div style={{ width: "20%", padding: 5 }}>
                                    <input checked={this.state.otpBySms} className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                                        onChange={() => { this.setState({ otpBySms: true }) }} />
                                </div>
                                <div style={{ width: "80%", paddingTop: 1 }}>
                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                        Otp sms
                                    </label>
                                </div>
                            </div>
                            <div style={{ width: "50%", display: "inline-flex" }}>
                                <div style={{ width: "20%", padding: 5 }}>
                                    <input checked={!this.state.otpBySms} className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2"
                                        onChange={() => { this.setState({ otpBySms: false }) }} />
                                </div>
                                <div style={{ width: "80%", paddingTop: 1 }}>
                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                        Otp email
                                    </label>
                                </div>
                            </div>
                        </div>}
                        {instance == "GuestAccess" && <br />}
                        {/* <div id="remember" className="checkbox">
                            <label>
                                <input type="checkbox" value="remember-me" /> Remember me
                             </label>
                        </div> */}
                        {!verifyOTP && instance && <a onClick={() => {
                            this.setState({ forgetPassword: true, Credentials: { password: "", username: "" } }, () => {
                            })
                        }} className="forgot-password">
                            Forgot the password?
                        </a>}
                        {instance == "GuestAccess" && <a className="register-user pull-right" href="/#GuestAccess/Register">Register</a>}
                        {instance && <div className="row padding-5">
                            <button disabled={!isValidData} className="btn btn-lg btn-fill btn-dark btn-block" type="button" onClick={() => this.authenticate()} >Sign in</button>
                            {mlogin && <button className="btn btn-lg btn-fill btn-danger btn-block" type="button" onClick={() => this.cancelCreds()} >Cancel</button>}
                        </div>}
                        {!instance && <div className="row padding-5">
                            <button disabled={!(Credentials.username && true)} className="btn btn-lg btn-fill btn-dark btn-block" type="button" onClick={() => this.clickSigninWithUsername()} >Next</button>
                            <a className="forgot-password pull-right" style={{ marginTop: "10px", fontSize: "16px" }} href="/#GuestAccess"> Sign in as Guest </a>
                        </div>}
                    </>}
                    {verifyOTP && <>
                        <input type="number" id="inputOTP" name="otp" className="form-control margin-10" placeholder={`Please enter the Code sent to your ${otpBySms ? "mobile" : "email"}`} onKeyPress={(e) => { if (e.charCode == 13) { this.verifyOTP() } }} required onChange={(e) => this.handleLoginForm(e)} />
                        <button disabled={!isValidData} className="btn btn-lg btn-fill btn-dark btn-block" type="button" onClick={() => this.verifyOTP()} >Verify Code</button>
                        <button className="btn btn-lg btn-fill btn-secondary btn-block" type="button" onClick={() => this.resendOTP()} >Resend Code</button>
                        <button className="btn btn-lg btn-fill btn-danger btn-block" type="button" onClick={() => this.cancel()} >Cancel</button>
                    </>}
                    {
                        forgetPassword && !verifyOTP &&
                        <>
                            <span id="reauth-email" className="reauth-email"></span>
                            <div className="row padding-5">
                                <input type="text" id="inputEmail" name="username" className="form-control" placeholder="User Name" required onChange={(e) => this.handleLoginForm(e)} />
                            </div>
                            <div className="row padding-5">
                                <button disabled={!isValidUser} className="btn btn-lg btn-fill btn-dark btn-block" type="button" onClick={async () => {
                                    this.manageSendEmail();
                                }} >Send Email</button>
                                <button className="btn btn-lg btn-fill btn-danger btn-block" type="button" onClick={() => {
                                    StorageUtils.clear();
                                    this.setState({ forgetPassword: false });
                                }} >Cancel</button>
                            </div>
                        </>
                    }
                    {
                        !forgetPassword && !verifyOTP && isEmailSent &&
                        <>
                            <div className="row padding-5">
                                <div className="col-md-12 center">
                                    <div className="login-form__header">An email is on it's way!</div>
                                </div>
                                <br />
                                <div className="col-md-12">
                                    <p>We sent an email to <b> email </b> to reset your Password.</p>
                                    <p>The link expires in 5 minutes, so be sure to use it soon.</p>
                                    <button className="btn btn-lg btn-fill btn-dark btn-block" type="button" onClick={async () => {
                                        this.setState({ isEmailSent: false, forgetPassword: false })
                                    }} >Go Back</button>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        )
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Components/People/Login.tsx